import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Card, CardImg, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Select } from "react-inputs-validation";
import { updateSucursalSeleccionada } from "../../redux/actions/aRamos"
import { ObtenerAyudaFetch } from "../../redux/actions/aCotizacion";
import Page from "components/Page";

class CardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Selectsucursales: this.props.usuarioSucursal,
      validate: false,
      hasSucursalError: false,
      SucursalSeleccionada: this.props.datosSucursales.sucursalSelecionadaAsesor
    };
    this.validateForm = this.validateForm.bind(this);
    this.openModal = this.openModal.bind(this);
  }


  async openModal(e, codigo, seccion) {
    e.preventDefault();
    //ObtenerAyudaMiddleware
    await this.props.obtenerAyuda(codigo, seccion);
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasSucursalError,
      Selectsucursales
    } = this.state;
    //console.log('All validated!', this.state);
    if (!hasSucursalError) {
      this.props.history.push({
        pathname: "/cotizacion",
        search: `?accion=nuevo`
      });
      //this.props.history.replace('/cotizacion')
      //console.log('All validated!');
    }
  }


  render() {
    const { ramos, sucursales } = this.props;
    const { Selectsucursales, SucursalSeleccionada } = this.state;
    let arraySucursales = [];
    arraySucursales.push({ id: "", name: "Selecciona una sucursal" });
    sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });
    return (
      <Page title="Ramos" breadcrumbs={[{ name: "ramos", active: true }]}>
        {ramos.map(r => {
          return (
            <Card className="flex-row">
              <Row>
                <div className="col-12 col-lg-4">
                  <CardImg
                    className="card-img-left"
                    src={r.ramUrlimagen}
                    style={{ width: 250, height: 140 }}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="col-12">
                    <table width="100%">
                      <tr>
                        <td width="95%">
                          <label className="card-title bold-font-label col-form-label">
                            {r.ramNombre}
                          </label>
                        </td>
                        <td width="5%">
                          <Button title="Ayuda Ramo Vehículos." className="btn btn-detail-white" onClick={(e) => this.openModal(e, "ramo-vehiculos", "ramos")}><i className="fa fa-question-circle-o" aria-hidden="true" /></Button>
                        </td>
                      </tr>
                    </table>
                    <p className="text-align-justify">{r.ramDescripcion}</p>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="col-12">
                    <label
                      for="exampleSelect"
                      className="bold-font-label col-form-label"
                    >
                      Surcursal
                    </label>
                    <div>
                      <Select
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"Selectsucursales"} // Optional.[String].Default: "". Input ID.
                        name={"Selectsucursales"} // Optional.[String].Default: "". Input name.
                        value={Selectsucursales} // Optional.[String].Default: "".
                        optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                        onChange={(Selectsucursales, e) => {
                          this.setState({ Selectsucursales });
                          this.props.updateSucursalSelecionada(Selectsucursales)
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "Selectsucursales", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione una sucursal"
                        }}
                      />
                      <p />
                      <Button className="btn btn-primary button-align-rigth" onClick={this.validateForm}>
                        COTIZAR
                      </Button>
                    </div>
                  </div>
                </div>
              </Row>
            </Card>
          );
        })}
        <div>
          <Modal isOpen={this.state.modal} toggle={this.openModal} className={this.props.className} centered={true} style={{ maxWidth: "70em" }}>
            <ModalHeader toggle={this.openModal} style={{ fontWeight: "600" }}>{this.props.datosAyuda.datosAyuda.titulo !== undefined ? this.props.datosAyuda.datosAyuda.titulo : ""}</ModalHeader>
            <ModalBody>
              {this.props.datosAyuda.datosAyuda.texto !== undefined ? this.props.datosAyuda.datosAyuda.texto : ""}
              <p></p>
              {this.props.datosAyuda.datosAyuda.mostrarImagen &&
                <CardImg src={this.props.datosAyuda.datosAyuda.urlimagen} style={{ width: "60%", height: "30vh", display: "block", margin: "auto" }} />
              }
              <p></p>
              {this.props.datosAyuda.datosAyuda.mostrarVideo &&
                // console.log(this.props.datosAyuda.datosAyuda.urlvideo) &&
                < iframe src={this.props.datosAyuda.datosAyuda.urlvideo} frameborder="0" allowFullScreen style={{ width: "60%", height: "30vh", display: "block", margin: "auto" }}></iframe>
              }

            </ModalBody>
          </Modal>
        </div>
      </Page >
    );
  }
}

const mapStateToProps = state => ({
  datosSucursales: state.datosSucursales,
  datosAyuda: state.datosAyuda
});
const mapDispatchToProps = dispatch => {
  return {
    updateSucursalSelecionada: (SucursalSelecionada) => dispatch(updateSucursalSeleccionada(SucursalSelecionada)),
    obtenerAyuda: (codigo, seccion) => dispatch(ObtenerAyudaFetch(codigo, seccion)),
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CardPage)
);
